import { type FunctionComponent, type PropsWithChildren } from 'react'
import { useCheckLaunchOnboardingProgress } from '@retailer-platform/dashboard/utils'

export const OnboardingVisibilityWrapper: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const { hasLaunchOnboarding } = useCheckLaunchOnboardingProgress()
  if (!hasLaunchOnboarding) return null
  return <>{children}</>
}
